





































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconQuoteSent',
  props: {
    width: {
      type: String,
      default: '90',
    },
    height: {
      type: String,
      default: '89',
    },
  },
});
